import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { JobCategoryService } from './job-category.service';
@Component({
  selector: 'app-job-category',
  templateUrl: './job-category.component.html',
  styleUrls: ['./job-category.component.scss'],
  providers: [JobCategoryService],
})
export class JobCategoryComponent implements OnInit {
  @Output() positionId = new EventEmitter();

  public categoryListes: any = [];

  constructor(
    public _categoryList: JobCategoryService
  ) { }

  ngOnInit() {
    // 获取岗位类别列表
    this.getCategoryListes();
  }
  // 获取岗位类别列表
  getCategoryListes() {
    this._categoryList.getjobCategory().then(resp => {
      this.categoryListes = resp['data'];
      // console.log("获取岗位类别列表", resp);
      this.categoryListes.map(row => {
        if (!row['children']) {
          row['children'] = [];
        }
      })
      // console.log("ee:", this.categoryListes);
    });
  }
  getCategoryId(position_industry_cid: number, position_industry_pid: number) {
    let obj = {};
    obj['position_industry_cid'] = position_industry_cid;
    obj['position_industry_pid'] = position_industry_pid;
    this.positionId.emit(obj);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/job-category/job-category.component.ts